import { Row, Card } from 'antd'

import FreePressStyle from '../../styles/DetriotFreePress.module.css'

const DetriotFreePress = () => {
  return (
    <div className={`${FreePressStyle["detroit-free-press-screen"]}`}>
      <Row justify="center">
        <Card className={`${FreePressStyle["detroit-free-press-card"]}`}>
          <article>
            <h2 className={`${FreePressStyle["detroit-free-press-above-title"]}`}>
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/"
                rel="noreferrer"
                target="_blank"
              >
                Detroit Free Press
              </a>
            </h2>
            <p>
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/business/"
                rel="noreferrer"
                target="_blank"
              >
                BUSINESS
              </a>
            </p>

            <hr />

            <h1 className={`${FreePressStyle["detroit-free-press-title"]}`}>
              New Michigan auto insurer doesn&apos;t use credit scores, charges lower rates
            </h1>

            <p className={`${FreePressStyle["detroit-free-press-author-name"]}`}>
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/staff/2647372001/jc-reindl/"
                rel="noreferrer"
                target="_blank"
              >
                JC Reindl
              </a>{' '}
              Detroit Free Press
            </p>
            <p>
              Published 6:04 a.m. ET July 9, 2021 | <b>Updated 9:08 p.m. ET July 10, 2021</b>
            </p>
            <hr />

            <p>
              Until last week, Patrick Palmer was paying an average of $295 a month to insure his 2008 Chevy
              Trailblazer.
            </p>
            <p>
              Even though he has a good driver discount, the 53-year-old Detroit resident admits to having a poor credit
              history, and credit history is typically a big factor in auto insurance rates in Michigan, especially
              high-cost urban areas like Detroit.
            </p>
            <p>Now Palmer is paying $128 a month after switching insurance companies.</p>
            <p>
              &quot;Man, it&apos;s a blessing,&quot; said Palmer, who works as a manager at a pizzeria.
              &quot;That&apos;s money I can keep in my pocket. I am living check to check.&quot;
            </p>
            <p>
              His new company, a small carrier known as CURE Auto Insurance or Citizens United Reciprocal Exchange,
              entered Michigan last week and is an auto insurance company — possibly the only one in Michigan — that
              doesn&apos;t use a credit score-like metric known as an &quot;insurance score&quot; when setting rates for
              drivers.
            </p>
            <p>
              Although studies have found a connection between lower insurance scores and the likelihood of a person
              filing a claim, consumer advocates say that their use is unfair and discriminatory because it makes
              insurance more expensive for the people who can least afford it.
            </p>
            <p>
              According to CUREs CEO Eric Poe, the not-for-profit company also is one of the few auto insurers that
              fully appreciate the big changes to insurance risk that happened with Michigan&apos;s 2019 overhaul of the
              no-fault system, and, unlike some bigger brandname insurance companies, CURE isn&apos;t hesitant to give
              customers significantly lower rates right away rather than waiting years for fuller data.
            </p>
            <p>
              CURE is now racing to add customers before those larger and hesitant insurance companies finally lower
              their rates across the state, Poe said. CURE previously only wrote policies in New Jersey and
              Pennsylvania, and waited until this month to enter Michigan because that is when new medical cost controls
              took effect as part of the 2019 overhaul.
            </p>
            <p>Poe says his company wouldn&apos;t be viable in Michigan without the cost controls</p>
            <p>
              <b>More:</b>{' '}
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/story/money/business/2021/03/20/auto-insurers-flocking-michigan-nofault-overhaul/4715789001/"
                rel="noreferrer"
                target="_blank"
              >
                New auto isurers flocking to michigan after no-fault overhaul
              </a>{' '}
            </p>
            <p>
              <b>More:</b>{' '}
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/story/money/business/michigan/2021/06/12/michigan-auto-insurance-no-fault-price/7590420002/"
                rel="noreferrer"
                target="_blank"
              >
                Some fear new michigan no-fault auto insurance rule will force victims into nursing homes
              </a>{' '}
            </p>
            <p>
              &quot;The market is not correctly reflecting what the actual reform laws are going to do in terms of
              losses, so, as a result, the rest of Michigan&apos;s auto insurance marketplace is not having rates that
              are as low as mine,&quot; Poe said. &quot;There is only going to be a three-year window of time before all
              the numbers come in and everybody in the market just drops their rates.&quot;
            </p>
            <p>
              New Jersey-based CURE is one of 28 auto insurers or new affiliates of insurers that have sought
              authorization to potentially join Michigan&apos;s insurance market since Gov. Gretchen Whitmer signed the
              no-fault overhaul. Of those, four insurers, including CURE, that are new to Michigan have been approved or
              are pending approval to start writing polices. The others are Arch Insurance, Berkley Insurance Co. and
              Branch Insurance.
            </p>
            <p>
              Poe said that for moral and ethical reasons, CURE doesn&apos;t consider credit scores or &quot;insurance
              scores&quot; or other non-driving factors such as education credentials, and instead relies primarily on
              customers&apos; driving history.
            </p>
            <p>
              He said CURE was eager to enter Michigan because the company got its start in 1990 when New Jersey was
              experiencing its own auto insurance affordability crisis. The company was started by Poe&apos;s mother, an
              insurance actuary, and his stepfather, a former New Jersey insurance commissioner.
            </p>
            <p>
              CURE is considered a reciprocal insurance exchange, which is when a group of people with similar
              backgrounds pool their premiums and share the combined risk to reduce everyone&apos;s premiums. Today, 88%
              of its 40,000-plus customers are in New Jersey and the others in Pennsylvania.
            </p>
            <p>
              &quot;The reason why we are boldly going into the state of Michigan is we are probably one of the few
              carriers that are small enough to know what happens with this (overhaul) bill,&quot; Poe said.
            </p>
            <p>
              &quot;We are not big enough to compete with publicly traded insurance carriers, but I will tell you this,
              they don’t take risk when they don’t need to. So what you tend to see when there are reform bills of this
              magnitude is the market is going to be very slow to react until they see the data. That’s what we
              experienced in New Jersey.&quot;
            </p>
            <p>
              Since CURE launched this month in Michigan, the cheapest policy it has done was $77 for six months, Poe
              said. That policy went to a customer in rural Michigan who chose liability-only coverage, $0 for personal
              injury protection or PIP and the minimum $50,000 bodily injury coverage.
            </p>
            <p>
              There have been multiple other policies in the $300s for six months, also with $0 PIP coverage, he said.
            </p>
            <p>
              Prior to July 2020, all Michigan policies had to include unlimited PIP and it was the most expensive
              component of insurance premiums in Detroit.
            </p>
            <p>
              For Palmer, his six-month policy for his dented 2008 Trailblazer came out to $729, plus a bit extra to pay
              in monthly installments.
            </p>
            <p>
              But what&apos;s unique about his policy is that unlike the rural Michigan customer with the sub-$100 rate,
              Palmer did not pick the absolute cheapest coverage options. His policy has $500,000 of PIP and $250,000
              per-person for bodily injury, according to a copy reviewed by the Free Press. (Like the rural customer,
              his policy also doesn&apos;t include collision coverage.)
            </p>
            <p>
              He could never understand why his auto insurance was so expensive for an older vehicle that wouldn&apos;t
              cost much to replace.
            </p>
            <p>&quot;Why should I pay that, especially for an old truck?&quot; he asked.</p>
            <p>
              Palmer said he first heard about CURE when he saw Poe giving a morning interview to a local TV station
              about the company arriving in Michigan.
            </p>
            <p>
              &quot;That was a blessing. I woke up right in time to see them talking about that on the news,&quot; he
              said. &quot;I am doing my best to see if I can get some of my friends over here, because once they see
              what I&apos;m paying and what they can be paying, they might switch.&quot;
            </p>

            <h5>Refundable deposit</h5>
            <p>
              All of CUREs policies charge customers a &quot;surplus contribution&quot; fund deposit on their base
              premium. This is a refundable deposit that goes to the benefit of all CURE members, and which customers
              get back if and when they decide to leave CURE. The deposit equals 25% of a customer&apos;s initial base
              premium, which for Palmer, came out to $146 on top of his $583 base, for a total premium of $729 for six
              months.
            </p>
            <p>
              So far, CUREs average Michigan six-month policy costs $758 — including the deposit, Poe said, and many of
              those customers aren&apos;t dropping PIP to get the lowest possible rates.
            </p>
            <p>
              &quot;Even with the 25% deposit, our out-of-pocket cost is still substantially lower than the
              market,&quot; he said.
            </p>
            <p>
              Poe acknowledged that CUREs stance against using credit-derived insurance scores could result in adverse
              selection, meaning that drivers with poorer credit history and higher statistical likelihood for filing
              claims might be disproportionately attracted to CURE — potentially causing financial problems in the
              future.
            </p>
            <p>
              But CURE has accounted for that risk, he said, and can still offer rates below what many other insurers
              have for good drivers with subpar credit histories.
            </p>

            <h5>The fine print</h5>
            <p>
              Michigan&apos;s 2019 overhaul of the auto no-fault system added new prohibitions against insurance
              companies using some non-driving factors when setting rates, specifically sex, marital status, home
              ownership, occupation and education level.
            </p>
            <p>
              However, the reform still allowed insurers to use insurance scores, which are variations of credit scores
              that can help predict the likelihood of someone filing a claim. Even though the legislation did include a
              line banning the use of &quot;credit scores,&quot; insurance companies generally don&apos;t use straight
              credit scores but rather &quot;insurance scores&quot; derived from credit scores.
            </p>
            <p>
              Douglas Heller, a prominent national consumer advocate who has followed Michigan&apos;s no-fault changes,
              said he thought this small-print detail was a sneaky thing.
            </p>
            <p>
              “The bill was written intentionally to look like it was prohibiting the use of credit while explicitly
              maintaining it exactly as it always was used,&quot; Heller said. &quot;No insurance carrier in Michigan
              ever used credit scores, they always used credit-based insurance scores, which are just credit scores with
              one credit factor weighted slightly differently. And whatever insurance companies have to say about it, it
              has nothing to do with whether you drive safely behind the wheel.&quot;
            </p>

            <h5>Lower risk, lower premiums</h5>
            <p>
              Insurance scores were developed in the 1990s and are now routinely used in states like Michigan where they
              are allowed. Proponents contend that the scores are a fair metric to use because drivers with better
              scores have a lower statistical likelihood of filing claims, and they can therefore benefit by getting
              lower premiums.
            </p>
            <p>
              &quot;Like your driving record, your credit rating is a helpful tool for car insurance companies to use
              when assessing your risk as a driver. However, insurance scores are not the sole factor used to underwrite
              and price insurance,&quot; said Loretta Worters, a spokesperson for the Insurance Information Institute,
              an industry-funded organization.
            </p>
            <p>
              Three states — California, Massachusetts and Hawaii — have completely banned the use of insurance scores
              in selling auto insurance. Nevada and Washington enacted temporary bans in response to the COVID-19
              pandemic.
            </p>
            <p>
              Heller said it is encouraging to see a new insurer in Michigan that doesn&apos;t use insurance scores,
              although he doubts the arrival of CURE is enough to help everyone who needs affordable insurance.
            </p>
            <p>
              &quot;One insurance company cannot serve the entire market of financially vulnerable consumers,&quot;
              Heller said. &quot;That&apos;s not a viable spreading of risk.&quot;
            </p>
            <p>
              ContactJC Reindl: 313-222-6631 or{' '}
              <a className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`} href="mailto:jcreindl@freepress.com">
                jcreindl@freepress.com
              </a>
              . Follow him on Twitter{' '}
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://twitter.com/jcreindl"
                rel="noreferrer"
                target="_blank"
              >
                @jcreindl
              </a>{' '}
              Read more on{' '}
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/business/"
                rel="noreferrer"
                target="_blank"
              >
                business
              </a>{' '}
              and sign up for our{' '}
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://profile.freep.com/newsletters/business-headlines/"
                rel="noreferrer"
                target="_blank"
              >
                business newsletter
              </a>
              .
            </p>

            <hr />
            <p className={`${FreePressStyle["detroit-free-press-foot-note"]}`}>
              <a
                className={`${FreePressStyle["detroit-free-press-hyperlinks"]}`}
                href="https://www.freep.com/story/money/business/2021/07/09/michigan-cure-auto-insurance-credit-scores/7880516002/?utm_source=freep-Daily"
                rel="noreferrer"
                target="_blank"
              >
                https://www.freep.com/story/money/business/
              </a>
            </p>
          </article>
        </Card>
      </Row>
    </div>
  )
}

DetriotFreePress.propTypes = {}

export default DetriotFreePress
